<template>
  <div>
    <div class="d-flex align-center justify-space-between">
      <h4>Scholar Result</h4>
      <v-btn
        class="text-capitalize"
        dark
        depressed
        @click="exportData"
        color="#016443"
      >
        Export Data
      </v-btn>
    </div>
    <div>
      <v-row align="center" class="my-2">
        <v-col cols="12" md="3">
          <p class="default_txt">Search</p>
          <v-text-field
            placeholder="Search Proposal"
            solo
            dense
            v-model="find"
            @keyup="fetchData"
            hide-details
            prepend-inner-icon="mdi-magnify"
            flat
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <p class="default_txt">Type</p>
          <v-select
            :items="optDestinationProposal"
            item-text="name"
            item-value="val"
            v-model="destination"
            placeholder="Destination"
            dense
            flat
            hide-details
            solo
            @change="fetchData"
          ></v-select>
        </v-col>
        <v-col cols="12" md="2">
          <p class="default_txt">Status</p>
          <v-select
            hide-details
            :items="optStatus"
            flat
            item-text="txt"
            dense
            solo
            item-value="val"
            v-model="approval"
            @change="fetchData"
            placeholder="Status"
          ></v-select>
        </v-col>
        <v-col cols="12" md="2">
          <p class="default_txt">Sort By</p>
          <v-select
            hide-details
            :items="optSort"
            flat
            dense
            item-text="txt"
            solo
            item-value="val"
            v-model="sort"
            @change="fetchData"
            placeholder="Sort data"
          ></v-select>
        </v-col>
        <v-col cols="12" md="2">
          <p class="default_txt">Year</p>
          <v-select
            dense
            hide-details
            :items="getYear"
            item-text="state"
            item-value="abbr"
            v-model="year"
            @change="fetchData()"
            placeholder="Filter Year"
            flat
            solo
          ></v-select>
        </v-col>
      </v-row>
    </div>

    <div>
      <div v-if="loading">
        <v-card class="my-2 pa-3 rounded-lg" v-for="i in 3" :key="i">
          <v-skeleton-loader type="list-item-avatar"></v-skeleton-loader>
        </v-card>
      </div>
      <div v-if="dataSet && !loading">
        <div
          v-if="!dataSet.length"
          class="d-flex flex-column align-center justify-center pa-3"
        >
          <img
            src="../../../assets/img/gundam/no_data_general.png"
            height="200px"
            alt=""
          />

          <h3 class="text-center">Data not found</h3>
        </div>
        <div v-else>
          <v-expansion-panels accordion multiple flat>
            <v-expansion-panel
              v-for="(item, i) in dataSet"
              :key="i"
              class="mb-2 rounded-lg"
            >
              <v-expansion-panel-header>
                <div>
                  <div class="d-flex align-center">
                    <h3 class="mr-2">{{ item.title }}</h3>
                    <v-card
                      class="pa-2"
                      flat
                      :color="
                        item.approval == 'approved'
                          ? '#006341'
                          : item.approval == 'declined'
                          ? '#FE0404'
                          : item.approval == 'revision'
                          ? '#B3A369'
                          : '#001A72'
                      "
                    >
                      <h4
                        style="
                          color: white;
                          text-transform: uppercase;
                          text-align: center;
                        "
                      >
                        {{ item.approval }}
                      </h4>
                    </v-card>
                  </div>
                  <div class="d-flex aligm-center">
                    <router-link
                      v-if="item.data_user"
                      :to="`/scholar/${item.user_id}`"
                      class="opener_name d-flex align-center mr-2"
                    >
                      <v-avatar size="25" class="mr-2">
                        <img
                          :src="
                            item.data_user.profile_picture
                              ? item.data_user.profile_picture
                              : ava
                          "
                          class="obj_fit"
                          alt="isyan"
                        />
                      </v-avatar>
                      <p class="mb-0 black--text">
                        by <b>{{ item.data_user.name }}</b>
                      </p>
                    </router-link>

                    <div class="d-flex align-center">
                      <p class="mb-0 mr-2">. at {{ item.proposal_created }}</p>
                      <p class="mb-0">. {{ item.destination }}</p>
                    </div>
                  </div>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div
                  class="mb-2 d-flex align-start"
                  v-if="item.approval == 'approved'"
                >
                  <v-icon color="#006341" class="mr-1">
                    mdi-square-edit-outline
                  </v-icon>
                  <div style="flex: 1">
                    <h5>Continuation of Sponsorship</h5>
                    <h5>For those who have been accepted for an Sponsorship</h5>
                    <v-row>
                      <v-col cols="6" md="3">
                        <v-card
                          outlined
                          height="100%"
                          color="#E8F5E9"
                          class="pa-3 d-flex flex-column align-center"
                          :to="`/admin/mp/dokumentasi-sponsorship/${item.id}`"
                        >
                          <v-icon color="var(--g)">mdi-content-paste</v-icon>
                          <b class="color_default text-center"
                            >Documentation Sponsorship</b
                          >
                        </v-card>
                      </v-col>
                      <v-col cols="6" md="3">
                        <v-card
                          outlined
                          height="100%"
                          color="#E8F5E9"
                          class="pa-3 d-flex flex-column align-center"
                          @click="finalReport(item.id)"
                        >
                          <v-icon color="var(--g)"
                            >mdi-text-box-check-outline</v-icon
                          >
                          <b class="color_default">Final Report</b>
                        </v-card>
                      </v-col>
                    </v-row>
                  </div>
                </div>
                <div class="mb-3 d-flex justify-end">
                  <v-btn
                    dark
                    color="var(--g)"
                    class="text-capitalize"
                    depressed
                    @click="exportHistory(item)"
                    >export progress</v-btn
                  >
                </div>
                <div
                  class="d-flex"
                  v-for="(history, k) in item.data_submission"
                  :key="`${k}-hist`"
                >
                  <div class="d-flex flex-column align-center">
                    <div
                      class="dot_out"
                      :style="`background: ${
                        history.history.approval == 'approved'
                          ? '#006341'
                          : history.history.approval == 'declined'
                          ? '#FE0404'
                          : history.history.approval == 'revision'
                          ? '#B3A369'
                          : '#001A72'
                      }`"
                    ></div>
                    <div
                      class="line_graph"
                      :style="`background: ${
                        history.history.approval == 'approved'
                          ? '#006341'
                          : history.history.approval == 'declined'
                          ? '#FE0404'
                          : history.history.approval == 'revision'
                          ? '#B3A369'
                          : '#001A72'
                      }`"
                    ></div>
                  </div>
                  <div class="ml-2" style="flex: 1">
                    <v-card outlined class="pa-2 mb-2">
                      <v-row>
                        <v-col cols="12" md="6">
                          <b class="mb-1 bold small_txt">
                            {{
                              $date(history.history.created_at).format(
                                "dddd, DD MMMM YYYY . HH:mm",
                              )
                            }}
                          </b>
                        </v-col>
                        <v-col cols="12" md="6">
                          <div
                            class="d-flex justify-end"
                            v-if="
                              !history.history.notes &&
                              (history.history.approval === 'revision' ||
                                history.history.approval === 'process')
                            "
                          >
                            <v-btn
                              small
                              depressed
                              dark
                              color="var(--g)"
                              @click="reviewProp(history)"
                            >
                              <v-icon small class="mr-1">mdi-pencil</v-icon>
                              Review</v-btn
                            >
                          </div>
                        </v-col>
                      </v-row>
                      <div>
                        <div class="d-flex align-start">
                          <v-icon small class="mr-2">mdi-clipboard</v-icon>
                          <a
                            :href="history.content"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <v-btn
                              class="text-capitalize"
                              depressed
                              color="var(--g)"
                              dark
                              @click="viewReqDoc(history)"
                              ><v-icon color="yellow">mdi-folder</v-icon>
                              Required Document</v-btn
                            >
                          </a>
                        </div>
                        <div class="d-flex align-start mt-2">
                          <v-icon small class="mr-2">mdi-text</v-icon>
                          <p class="mb-0 small_txt">
                            {{ history.description }}
                          </p>
                        </div>
                        <div class="d-flex align-start mt-2 pb-1">
                          <v-icon small class="mr-2">mdi-progress-clock</v-icon>
                          <v-card flat class="px-2 d-flex">
                            <b
                              class="small_txt mb-0 mr-2"
                              :style="`color: ${
                                history.history.approval == 'approved'
                                  ? '#006341'
                                  : history.history.approval == 'declined'
                                  ? '#FE0404'
                                  : history.history.approval == 'revision'
                                  ? '#B3A369'
                                  : '#001A72'
                              }`"
                            >
                              {{ history.history.approval }}
                            </b>
                            <p
                              class="small_txt mb-0"
                              v-if="history.history.notes"
                            >
                              : {{ history.history.notes }}
                            </p>
                          </v-card>
                        </div>
                      </div>
                    </v-card>
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <div class="text-center pa-3">
            <v-pagination
              v-model="page"
              color="#006341"
              @input="fetchData"
              :length="last_page"
            ></v-pagination>
          </div>
        </div>
      </div>
    </div>
    <div class="pa-2">
      <review-proposal
        :r_prop="r_prop"
        @close="r_prop = false"
        @refetch="fetchData"
        :inventory="inventory"
        :title="d_title"
      />
      <view-required-doc
        :d_up="d_up"
        @close="d_up = false"
        :inventory="inventory"
      />
      <final-report-proposal
        :d_fr="d_fr"
        @close="d_fr = false"
        :inventory="inventory"
        :disabled="true"
      />
      <v-snackbar v-model="snack" :timeout="-1"> getting data </v-snackbar>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ViewRequiredDoc from "../../profile/scholar/report/viewRequiredDoc.vue";
import FinalReportProposal from "../../profile/scholar/proposal/finalReportProposal.vue";
import reviewProposal from "../reviewProposal.vue";
export default {
  components: { reviewProposal, ViewRequiredDoc, FinalReportProposal },
  name: "listResponseSponsorship",
  computed: {
    ...mapState({
      permissions: (state) => state.permissions,
      role: (state) => state.role,
      ava: (state) => state.ava,
    }),
    getYear() {
      let data = [];
      let year = parseInt(this.$date().format("YYYY"));
      for (let i = 2019; i <= year; i++) {
        data.push({
          state: i,
          abbr: i,
        });
      }
      data.push({
        state: "All Year",
        abbr: "",
      });
      return data;
    },
  },
  data() {
    return {
      loading: false,
      snack: false,
      d_fr: false,
      dataSet: null,
      page: 1,
      year: "",
      limit: 10,
      find: "",
      d_up: false,
      r_prop: false,
      d_large: false,
      inventory: "",
      d_type: "",
      d_title: "",
      hide_title: "",
      btnTitle: "",
      destination: "",
      approval: "",
      sort: "",
      optSort: [
        { txt: "Newest", val: "-scholar_sponsor_proposal.created_at" },
        { txt: "Oldest", val: "scholar_sponsor_proposal.created_at" },
      ],
      optStatus: [
        { txt: "All Status", val: "" },
        { txt: "Process", val: "process" },
        { txt: "Approved", val: "approved" },
        { txt: "Declined", val: "declined" },
        { txt: "Revision", val: "revision" },
      ],
      optDestinationProposal: [
        { name: "All", val: "" },
        { name: "Research", val: "Research" },
        { name: "Conferences", val: "Conferences" },
        { name: "Competition", val: "Competition" },
        {
          name: "Professional Certification",
          val: "Professional Certification",
        },
      ],
      headers: [
        {
          text: "Name",
          align: "start",
          value: "name",
        },
        {
          text: "ID",
          align: "start",
          value: "no_tf",
        },
        {
          text: "Title",
          align: "start",
          value: "title",
        },
        {
          text: "Type",
          align: "start",
          value: "destination",
        },
        {
          text: "Submitted Date",
          align: "start",
          value: "created_at",
        },
        {
          text: "Latest proposal status",
          align: "start",
          value: "approval",
        },
        { text: "Actions", sortable: false, value: "actions" },
      ],
    };
  },
  mounted() {
    this.fetchData();
    this.getQuestion();
  },
  methods: {
    getQuestion() {
      let data = {
        path: `scholar/proposal/sponsorships/question`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.frQuestion = data.data;
          this.frQuestion.forEach((el) => {
            el["answer"] = "";
          });
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },
    finalReport(id) {
      this.snack = true;
      let data = {
        path: `proposal/sponsorships/report?filter[scholar_sponsor_proposal_id]=${id}&sort=created_at`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.frQuestion.forEach((q) => {
            data.data.forEach((a) => {
              if (q.id == a.id) {
                q["answer"] = a.answer;
              }
            });
          });
          this.inventory = {
            question: this.frQuestion,
            path: "scholar/proposal/sponsorships/question",
            id: "scholar_sponsor_proposal_report_question_id",
            body: {
              scholar_sponsor_proposal_id: id,
              type: "text",
            },
          };
          this.d_fr = true;
          this.snack = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.snack = false;
        });
    },

    fetchData() {
      this.loading = true;
      let data = {
        path: `proposal/sponsorships?page[number]=${this.page}&page[size]=${this.limit}&filter[year]=${this.year}&filter[search]=${this.find}&sort=${this.sort}&filter[destination]=${this.destination}&filter[approval]=${this.approval}&include=dataUser,dataProposal,dataSubmission`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.loading = false;
          this.dataSet = data.data;
          this.total = data.total;
          this.last_page = data.last_page;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    viewReqDoc(item) {
      let data = [
        {
          title:
            "Acceptance/Invitation/Confirmation from organizer (for competitions, conferences, courses) or Cover letter from university (for research)",
          content: item.attach_letter,
        },
        {
          title:
            "Confirmation of active contribution in your TSA (from Head of TSA) – optional for TELADAN Non-Regular",
          content: item.attach_confirmation,
        },
        {
          title: "Copy KTP",
          content: item.attach_ktp,
        },
        {
          title: "Copy front page of 'Bank Account'",
          content: item.attach_tabungan,
        },
      ];
      this.inventory = data;
      this.d_up = true;
    },
    reviewProp(item) {
      this.d_title = "Proposal Sponsorhip";
      let body = {
        id: item.scholar_sponsor_proposal_id,
        approval: item.history.approval,
        scholar_sponsor_proposal_submission_id: item.id,
        notes: item.history.notes,
      };
      this.inventory = {
        body: body,
        path: `proposal/sponsorships`,
      };
      this.r_prop = true;
    },
    exportHistory(item) {
      let data = {
        path: `proposal/internships/history?scholar_sponsor_proposal_id=${item.id}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          location.href = data.path;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },
    exportData() {
      let data = {
        path: `export/proposal-sponsorship`,
        body: {
          "filter[destination]": this.destination,
          "filter[approval]": this.approval,
          "filter[search]": this.find,
          sort: this.sort,
        },
      };
      this.$store.dispatch("exportData", data);
    },
  },
};
</script>

<style scoped>
.btn {
  text-transform: unset !important;
}
.dot_out {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  /* background: green; */
}
.line_graph {
  width: 2px;
  /* background: green; */
  height: 100%;
  margin-top: -5px;
}
</style>
